import styled from "styled-components";
import { TABLET_M_BP } from "@website-builder/utilities/constants/style-constants/screen-sizes.js";

export const OverlappingCardWrapper = styled.div`
	padding-bottom: ${({ isMobile }) => (isMobile ? "40px" : "80px")};
	background: ${({
		topBackgroundColor = "var(--primary-green-50)",
		bottomBackgroundColor = "var(--primary-neutral-white)",
	}) =>
		`linear-gradient(180deg, ${topBackgroundColor}  0 calc(50% - 2.5rem), ${bottomBackgroundColor}  calc(50% - 2.5rem) 100%)`};
	.card-container {
		padding: 3rem 4rem;
		display: flex;
		background: ${({
			contentBackgroundColor = "var(--primary-neutral-white)",
		}) => contentBackgroundColor};
		color: ${({ isDarkBackground }) =>
			isDarkBackground
				? "var(--primary-neutral-white)"
				: "var(--primary-neutral-nightshade-800)"};
		.description-wrapper {
			color: ${({ isDarkBackground }) =>
				isDarkBackground
					? "var(--primary-neutral-white)"
					: "var(--primary-neutral-nightshade-600)"};
			.description {
				margin: 1rem 0;
			}
		}
		.media-grid-margin {
			margin: 0px 40px;
		}
		& img {
			width: 100%;
		}
		& > div {
			margin: 0;
			align-self: center;
		}
		.media-container img {
			width: 100%;
			border-radius: 0.5rem;
		}
	}
	@media only screen and (max-width: ${TABLET_M_BP}px) {
		.grid-container {
			margin: 0 1.5rem;
		}
		.card-container {
			padding: 2.5rem 1.5rem;
		}
	}
`;
